/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bank-card': {
    width: 259.18,
    height: 200,
    viewBox: '0 0 1327 1024',
    data: '<defs/><path pid="0" d="M0 256v85.333h1327.407V256H0zm729.164 453.215h-74.676l-80.214 157.392h76.535zm165.926 0h-74.676l-76.497 157.392h76.497zm309.74 0H983.572l-73.766 157.392h217.543zM1171.609 0a155.496 155.496 0 01110.933 48.849 164.636 164.636 0 0144.866 115.18V859.97a164.674 164.674 0 01-44.866 115.22 155.496 155.496 0 01-110.933 48.81H157.62a155.496 155.496 0 01-110.933-48.81A164.674 164.674 0 011.82 859.97V164.03A160.085 160.085 0 01156.71 0h1014.898zm0 0"/>'
  }
})
